import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/mock';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('gangnam-playground-lang');
    return saved || null;
  });

  const [showGate, setShowGate] = useState(() => {
    return !localStorage.getItem('gangnam-playground-lang');
  });

  useEffect(() => {
    if (language) {
      localStorage.setItem('gangnam-playground-lang', language);
    }
  }, [language]);

  const selectLanguage = (lang) => {
    setLanguage(lang);
    setShowGate(false);
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ko' ? 'en' : 'ko');
  };

  const t = (key) => {
    return translations[language || 'ko'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ 
      language: language || 'ko', 
      showGate, 
      selectLanguage, 
      toggleLanguage, 
      t 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};